import { render } from "./ProductVideoView.vue?vue&type=template&id=30afd5be&scoped=true"
import script from "./ProductVideoView.vue?vue&type=script&lang=js"
export * from "./ProductVideoView.vue?vue&type=script&lang=js"

import "./ProductVideoView.vue?vue&type=style&index=0&id=30afd5be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30afd5be"]])

export default __exports__